import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { AsyncPipe } from '@angular/common';
import { AdminService } from '@Services';
import { Notification } from '@Models';

@Component({
  selector: 'app-notification',
  imports: [AsyncPipe],
  templateUrl: './notification.component.html',
  styleUrl: './notification.component.css',
})
export class NotificationComponent {
  notificationExtract$: Observable<Notification[] | null> | null = null;
  url = `UserNotifications`;

  constructor(private _adminService: AdminService) {
    this.notificationExtract$ = this._adminService.getAllNotifications();
  }
}
